import { jsx as n } from "react/jsx-runtime";
import { classes as s } from "../../utils/styles.js";
import t from "./button.module.js";
const y = ({
  children: r,
  onClick: l,
  disabled: d,
  variant: m = "primary",
  size: o,
  expand: u,
  href: e,
  className: a,
  contentClassName: c,
  ...b
}) => {
  const i = s([
    t.button,
    t[m],
    ...u ? [t.expanded] : [],
    ...o ? [t[o]] : []
  ]), p = s([
    ...a ? [a] : [],
    t.buttonLink,
    t[m],
    ...u ? [t.expanded] : [],
    ...o ? [t[o]] : []
  ]);
  return e ? /* @__PURE__ */ n("a", { href: e, className: p, ...b, children: /* @__PURE__ */ n(
    "div",
    {
      className: s([
        ...c ? [c] : [],
        t.content
      ]),
      children: r
    }
  ) }) : /* @__PURE__ */ n(
    "button",
    {
      disabled: d,
      className: i,
      onClick: l,
      ...b,
      children: r
    }
  );
};
export {
  y as Button
};
